import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="image-uploading"
export default class extends Controller {
  static targets = ["fileInput", "previewCanvas", "customButton"];

  connect() {
    // console.log("CustomFileInput controller connected");
  }

  // Trigger the hidden file input when the custom button is clicked
  triggerInput(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  // Handle file selection and display a preview
  showPreview() {
    const input = this.fileInputTarget;
    const files = input.files;
    const previewCanvas = this.previewCanvasTarget;

    if (files && files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        previewCanvas.src = e.target.result;
      };
      reader.readAsDataURL(files[0]); // Display the file name
    }
  }
}
